export const FirebaseConfig = {
  apiKey: "AIzaSyCf_zDfT9_OdnZ3aTBgLMGeZFHMZEbdehU",
  authDomain: "ed-v1-4c4db.firebaseapp.com",
  databaseURL: "https://ed-v1-4c4db.firebaseio.com",
  projectId: "ed-v1-4c4db",
  storageBucket: "ed-v1-4c4db.appspot.com",
  messagingSenderId: "468440082009"
};

export const MixpanelKey = {
  key: "89499bfcd61c263d2ccb0735a0493204"
};
